import { useMemo } from 'react';
import endpoints from '@services/api/endpoints';
import useFetch from '@services/api/useFetch';
import type { NewsletterTypeSearchResults } from 'types/lists';

export const useNewsletterTypesApi = () => {
  const api = useFetch();
  return useMemo(() => {
    return {
      async list(): Promise<NewsletterTypeSearchResults> {
        return api.get(endpoints.lists.newsletterTypes.list);
      },
    };
  }, [api]);
};

export const newsletterTypesApiKeys = {
  all: ['newsletter-types'] as const,
  get: (id: string) => [...newsletterTypesApiKeys.all, id] as const,
  list: () => [...newsletterTypesApiKeys.all, 'newsletter-type-list'] as const,
};
